import styled from 'styled-components'
import { white, scrimDark } from '@/theme/colors'
import { radii, media, motion, layers } from '@/theme/tokens'
import { fontSizes, leading, text } from '@/theme/typography'

export const ViewerBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${scrimDark};
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: ${layers.viewer};
	padding: 32px;

	${media.phone} {
		padding: 16px;
	}
`

export const ViewerContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;

	img {
		max-width: 90vw;
		max-height: 80vh;
		object-fit: contain;
		border-radius: ${radii.small};
	}
`

export const ViewerControls = styled.div`
	display: flex;
	gap: 12px;
`

export const ViewerButton = styled.button`
	background: ${white}26;
	color: ${white};
	border: none;
	padding: 8px 16px;
	border-radius: ${radii.small};
	font-size: ${fontSizes.small};
	font-weight: 500;
	cursor: pointer;
	transition: background ${motion.base};
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover:not(:disabled) {
		background: ${white}40;
	}

	&:disabled {
		opacity: 0.4;
		cursor: default;
	}
`

/** Which photo of how many a gallery is on: "2 / 5". */
export const ViewerCount = styled.span`
	${text.caption}
	align-self: center;
	color: ${white};
`

export const ViewerCloseButton = styled.button`
	position: absolute;
	top: -40px;
	right: -16px;
	background: transparent;
	border: none;
	color: ${white};
	font-size: ${fontSizes.display};
	cursor: pointer;
	padding: 4px;
	line-height: ${leading.none};

	&:hover {
		opacity: 0.7;
	}

	${media.phone} {
		top: -32px;
		right: 0;
	}
`
